import FormController from "./form_controller";

export default class extends FormController {
  static values = {
    paymentsUrl: String,
    paymentMethodClientRequestUrl: String,
  };

  paymentMethodUpdatePayload = () => {
    const formData = { billing_country: "US" };

    // Iterate over all input elements and select elements within the form
    this.element.querySelectorAll("input, select").forEach((input) => {
      // Define the prefix
      const prefix = "payment_method[";

      // Extract the actual field name by removing the prefix and the closing bracket
      const fieldName = input.name.startsWith(prefix)
        ? input.name.slice(prefix.length, -1)
        : input.name;

      if (
        [
          "card_cvv",
          "billing_email",
          "billing_phone",
          "billing_name",
          "billing_street",
          "billing_street2",
          "billing_city",
          "billing_zip",
          "billing_state",
        ].includes(fieldName)
      ) {
        // Add the input value to the formData object using the actual field name as key
        formData[fieldName] = input.value;
      }

      let cardMonth, cardYear;

      switch (fieldName) {
        case "card_number":
          formData["card_number"] = input.value.replace(/\s/g, "");
          break;
        case "card_exp":
          [cardMonth, cardYear] = input.value.split("/");
          formData["card_month"] = cardMonth;
          formData["card_year"] = `20${cardYear}`;
          break;
      }
    });

    return { payment_method: formData };
  };

  sendPaymentMethodToPayments = () => {
    const url = this.paymentsUrlValue;
    const body = this.paymentMethodUpdatePayload();

    return fetch(url, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
  };

  onSubmit = async (event) => {
    event.preventDefault();

    if (!this.validateForm()) return this.firstInvalidField.focus();

    const res = await this.sendPaymentMethodToPayments();
    const body = await res.json();

    if (body.error) return this.handlePaymentMethodError(body.error);

    window.location.href = this.paymentMethodClientRequestUrlValue;
  };

  handlePaymentMethodError = (error) => {
    this.formFields.forEach((field) => {
      const trimmed_name = this.extractBracketContent(field.name);
      if (trimmed_name in error.details) {
        field.classList.toggle("invalid", true);
        this.showErrorForInvalidField(field, error.details[trimmed_name].join("\n"));
      }
    });
  };

  extractBracketContent = (input) => {
    const regex = /\[(.*?)\]/;
    const match = input.match(regex);

    if (match) {
      return match[1];
    } else {
      return input;
    }
  };
}
